// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__1e9Vg","LoaderWrapper":"Loader_LoaderWrapper__2r95y"};